module.exports = __webpack_public_path__ + "static/SFMono-SemiboldItalic-41da0311eaa7077546785a822a6ba21a.woff";